<template>
    <div class="annt-flielist-wrapper">
        <el-dropdown ref="dropdown" trigger="click" @visible-change="handleVisible" :hide-on-click="false">
            <div class="dropdown-title">
                <el-button type="text" icon="icon iconfont icon-button icon-wenjianliebiaoxiazaiicon">文件列表</el-button>
            </div>
            <template #dropdown>
                <div class="apps-select-dropdown">
                    <el-dropdown-menu>
                        <download-file-list ref="uploadlist"></download-file-list>
                    </el-dropdown-menu>
                </div>
            </template>
        </el-dropdown>
    </div>
</template>

<script>
import DownloadFileList from './DownloadFileList.vue';
export default {
    name: 'AnntFileList',
    data() {
        return {
            fileListVisible: false
        };
    },
    mounted() {
    },
    methods: {
        handleVisible(val) {
            if (val && this.$refs.uploadlist) {
                this.$refs.uploadlist.refresh();
            }
        }
    },
    components: {
        DownloadFileList
    }
};
</script>
